module.exports = __webpack_public_path__ + "static/img/Frame2508@2x.cbf72af.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Frame2508@2x.png
// module id = mLJ8
// module chunks = 1